import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { Vendor } from './vendor';

@JsonObject('model.cv.MaterialType')
export class MaterialType extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

}